"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types"); // Importing prop-types for validation
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const button_1 = __importStar(require("@kyruus/button"));
const ArrowLeft2_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft2"));
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Tracking_1 = require("../../lib/constants/Tracking");
const configUtils_1 = require("../../lib/configUtils");
const utils_1 = require("../../lib/utils");
const MobileHeaderLayout = (0, react_1.forwardRef)(({ onGoBack, headerText, config, featureFlags, backToSearchPageURL, searchMatchEnabled, isBackButtonVisible, track, intl }, ref) => {
    return (react_1.default.createElement(styles_1.MobileHeaderContent, { ref: ref },
        react_1.default.createElement(button_1.default, { "data-testid": "backButton", style: isBackButtonVisible ? {} : { display: 'none' }, "aria-label": intl.formatMessage(messages_1.default.ariaGoBackToPreviousStep), mode: "flat", onClick: () => {
                track(Tracking_1.userEvents.GO_BACK_TO_PREVIOUS_STEP);
                onGoBack();
            } },
            react_1.default.createElement(ArrowLeft2_1.default, { "aria-hidden": true, size: "24px" })),
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, headerText)),
        (0, utils_1.isBackToSearchBtnRendered)({
            backToSearchPageURL,
            searchMatchEnabled
        }) &&
            !(0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags) && (react_1.default.createElement(button_1.ButtonLink, { "data-testid": "cancelButton", mode: "flat", active: true, "aria-label": intl.formatMessage(messages_1.default.ariaBackToSearchPageButton), href: backToSearchPageURL, onClick: () => track(Tracking_1.userEvents.BACK_SEARCH_PAGE_BUTTON_CLICK_MOBILE) },
            react_1.default.createElement(Cancel_1.default, { "aria-hidden": true, size: "24px" })))));
});
MobileHeaderLayout.displayName = 'MobileHeaderLayout';
MobileHeaderLayout.propTypes = {
    onGoBack: prop_types_1.func.isRequired,
    headerText: prop_types_1.object.isRequired,
    backToSearchPageURL: prop_types_1.string,
    searchMatchEnabled: prop_types_1.bool.isRequired,
    isBackButtonVisible: prop_types_1.bool.isRequired,
    config: prop_types_1.object.isRequired,
    track: prop_types_1.func.isRequired,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    featureFlags: (0, prop_types_1.shape)({
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool
    })
};
exports.default = (0, intl_1.injectIntl)(MobileHeaderLayout);
//# sourceMappingURL=MobileHeaderLayout.js.map